/**
 * Truncate string to max length with ellipsis
 */
export const truncate = (s: string, max: number = 22): string =>
  s.length > max ? `${s.slice(0, max - 1)}…` : s;
